<div class="input-files-wrapper">
  <ng-container *ngIf="(!value && !arrayRejectedFiles.length) || multiple">
    <label tuiInputFiles class="input-files input-files_size_{{ size }}">
      <input
        tuiInputFiles
        [ngModel]="value"
        (ngModelChange)="valueChange($event)"
        [maxFileSize]="maxFileSize"
        [multiple]="multiple"
        [accept]="accept"
        [attr.capture]="capture"
        [tuiSkeleton]="loading"
        (reject)="rejectFile($event)"
      />

      <ng-template>
        <div *ngIf="!loading" class="input-files__content text_size-{{ size === 'm' ? 's' : 'm' }}">
          <ng-container *ngIf="!!link || !!label; else baseLabelTmp">
            <span *ngIf="!!link" class="link">
              {{ link }}
            </span>

            <span *ngIf="!!label" class="label">
              {{ label }}
            </span>
          </ng-container>

          <ng-template #baseLabelTmp>
            <span class="link">Выберите файл &nbsp;</span>
            <span class="label">или перетащите его сюда</span>
          </ng-template>
        </div>
      </ng-template>
    </label>
  </ng-container>

  <button
    *ngIf="multiple"
    tuiIconButton
    type="button"
    [appearance]="'outline'"
    [iconStart]="'@tui.trash-2'"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [tuiHint]="'components.loyaltyCommonStep.buttons.deleteFiles' | translate"
    [size]="size"
    (click)="removeAllFiles()"
  ></button>
</div>

<tui-files *ngIf="!!arrayFiles.length || !!arrayRejectedFiles.length" [ngClass]="multiple ? 'tui-space_top-1' : ''">
  <tui-file
    *ngFor="let file of arrayFiles"
    class="size_{{ size }}"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [file]="file"
    [showDelete]="showDelete"
    (remove)="removeFile(file)"
  >
    <ng-container *ngIf="contentTemplate; else defaultContentTmp">
      <ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: file }"></ng-container>
    </ng-container>

    <ng-template #defaultContentTmp>
      <app-download-link
        *ngIf="file?.id"
        class="text_size-s"
        [fileId]="file?.id"
        [isModeration]="isModeration"
        [showIcon]="false"
        [pseudo]="false"
      >
        {{ 'common.buttons.download' | translate }}
      </app-download-link>
    </ng-template>
  </tui-file>

  <tui-file
    *ngFor="let file of arrayRejectedFiles"
    class="size_{{ size }}"
    state="error"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [file]="(file | tuiFileRejected: { accept, maxFileSize } | async) || file"
    (remove)="removeRejectedFile(file)"
  ></tui-file>
</tui-files>
